import React from 'react';
import classNames from 'classnames';
import QRCode from "qrcode.react";
import { withStyles } from '@mui/styles';
import runtimeEnv from '@mars/heroku-js-runtime-env';

const styles = theme => ({
  root: {
    backgroundColor: "white",
    width: "100%",
    height: "100vh",
    padding: "10px",
    display: "flex",
    alignItems: "center"
  },
  svg: {
    margin: "0 auto",
    display: "block"
  }
});

const env = runtimeEnv();

const OptInQr = ({ hotel, classes }) => {

  return (
    <div className={classNames(classes.root)}>
      <QRCode
        className={classNames(classes.svg)}
        value={`${env.REACT_APP_URL}/hotel/${hotel.slug}?through_qr=true`}
        bgColor={"#ffffff"}
        fgColor={"#000000"}
        level={"L"}
        size={256}
        includeMargin={false}
        renderAs={"svg"}
        imageSettings={{
          src: "/assets/images/logos/ivy_logo.png",
          x: null,
          y: null,
          height: 65,
          width: 65
        }}
      />
    </div>
  );
};

export default (withStyles(styles, {withTheme: true})(OptInQr));
